import { Grid, Hidden } from "@material-ui/core";
import React from "react";

export default function DashboardTiles(props) {
  return (
    <>
      <Hidden lgUp>
        <Grid style={{ minWidth: "100%" }} item>
          {props.children}
        </Grid>
      </Hidden>
      <Hidden mdDown>
        <Grid xs sx={{ flex: "1 0 calc(100% / 7)" }} item>
          {props.children}
        </Grid>
      </Hidden>
    </>
  );
}
